/**
 * The extension pacer's own bookkeeping rows (FE offer holds / drops, pacer skips). They are written as
 * `before-wa-send` attempt logs so ops can see why a pending message went quiet, but they are NOT send attempts
 * or WhatsApp state reports: the backend reaper (reap-wa-evidence.ts) must treat them as neutral evidence.
 *
 * One module owns the wording so the writer (FE offer-holds.ts) and the reader (BE PACER_BOOKKEEPING_LOG_RE)
 * cannot drift. No message content ever goes in these strings: minutes and a reason token only.
 */

export type PacerSkipReason = 'local_expiry' | 'implausible_due'

export function offerHeldLogText(holdMinutes: number, reason: string): string {
    return `Offer held ${holdMinutes} min by this extension (${reason}); not re-offered until then`
}

export function offerDroppedLogText(reason: string): string {
    return `Offer dropped: never re-offered by this extension (${reason}); the server reaper will terminalize it`
}

export function pacerSkipLogText(reason: PacerSkipReason): string {
    return reason === 'local_expiry'
        ? `Not offered by this extension (${reason}): past its local expiry backstop; the server reaper will terminalize it`
        : `Not offered by this extension (${reason}): an attempted message dated past the plausibility bound`
}

/** Anchored prefixes of the three texts above; case-exact (no `i` flag), usable as a Mongo `$regexMatch` source. */
export const PACER_LOG_PREFIX_RE = /^(Offer held \d+ min by this extension|Offer dropped: never re-offered by this extension|Not offered by this extension)/
